import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="messageTips";
export function selectAll(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectAll`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function getUnReadCount() {
  return axios({
    url: `/ws/${moduleName}/getUnReadCount`,
    method: 'get',
  })
}

export function updateReadStatus(messageIds) {
  let parameter = {messageIds: messageIds}
  return axios({
    url: `/ws/${moduleName}/updateReadStatusByIds`,
    method: 'put',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export default {
  selectAll,
  getUnReadCount,
  updateReadStatus
}